export const API_PATH = "https://subdomain.wizwotc.com";
export const PER_PAGE = 7;
export const FORM_URL = "https://wizwotc.com/#/employee-form";
